export default "__VITE_PUBLIC_ASSET__e9e0841d__"